import React from 'react';
import Form from '../components/Form';
import Navbar from '../components/Navbar';
import HeroImage from '../components/HeroImage';
import Footer from '../components/Footer';

const Contact = () => {
    return (
        <>
        <Navbar/> 
        <HeroImage titel ='Contact.' text="Talk To us." /> 
        <Form/> 
        <Footer/> 
        </>
    );
}

export default Contact;
